import { CustomCellRendererProps } from 'ag-grid-react'

import { useTradeStrategiesQuery } from '@/react-query/queries/static'

export interface StrategyIdCellRendererProps extends CustomCellRendererProps<{
  client_id: number | null
}> {}

export const StrategyIdCellRenderer: React.FC<StrategyIdCellRendererProps> = ({ value }) => {
  const query = useTradeStrategiesQuery()

  const label = query.data?.find((t) => t.strategy_id === value)?.strategy_name ?? value

  return <>{label}</>
}
